<template>
  <div class="home">
    <div class="content">
      <div class="top">
        <div class="center">
          <div :class="['day-month',`${dayShow === true ? 'day-change-img' : 'month-change-img'}`]">
             <div
              :class="['day', `${dayShow === true ? 'click-css' : ''}`]"
              @click="handleChangeDayCss"
            >
              <!-- 今日 -->
              <div :class="`${dayShow === true ? 'click-css' : ''}`">
                <span class="font-day">
                  今日
                </span>
              </div>
            </div>
            <div
              :class="['month', `${monthShow === true ? 'click-css' : ''}`]"
              @click="handleChangeMonthCss"
            >
              <div :class="`${monthShow === true ? 'click-css' : ''}`">
                <span class="font-month">
                  当月
                </span>
              </div>
            </div>
          </div>

          <div class="day-all" v-if="dayShow">
            <div class="center-money">
              <div class="center-money-left">
                <div class="center-money-title">开票金额 (含税)</div>
                <div class="money-num">
                  {{ none ? Object.keys(dataSource).length > 0 ? (setMonths(dataSource.currDayStatistics.totalAmount) || '0.00') : '0.00' : setMoney(dataSource.currDayStatistics.totalAmount) }}
                </div>
              </div>
              <div class="hr"></div>
              <div class="center-money-right">
                <div class="center-money-title">
                  开票张数 <span @click="handleNone" class="huisuiyunfont">{{none ? '\ue619' : '\ue618'}}</span>
                </div>
                <div class="money-num">
                  {{ none ? Object.keys(dataSource).length > 0 ? (dataSource.currDayStatistics.totalNum || '0') : '0' : "**" }}
                </div>
              </div>
            </div>
            <van-cell-group>
              <van-cell
                to="/invoice/data-center"
                title="查看更多数据"
                is-link

              />
            </van-cell-group>
          </div>
          <div class="month-all" v-else>
            <div class="center-money">
              <div class="center-money-left">
                <div class="center-money-title">开票金额 (含税)</div>
                <div class="money-num">
                  {{
                    none
                      ? (Object.keys(dataSource).length > 0 ? setMonths(dataSource.currMonthStatistics.totalAmount) || '0.00' : '0.00')
                      : setMoney(dataSource.currMonthStatistics.totalAmount)
                  }}
                </div>
              </div>
              <div class="hr"></div>
              <div class="center-money-right">
                <div class="center-money-title">
                  开票张数 <span @click="handleNone" class="huisuiyunfont">{{none ? '\ue619' : '\ue618'}}</span>
                </div>
                <div class="money-num">
                 {{
                    none ? (Object.keys(dataSource).length > 0 ? dataSource.currMonthStatistics.totalNum || '0' : '0') : "**"
                  }}
                </div>
              </div>
            </div>
            <van-cell-group>
              <van-cell
                to="/invoice/data-center"
                title="查看更多数据"
                is-link
              />
            </van-cell-group>
          </div>
        </div>
        <div class="menu">
          <div @click="handleGo('/invoice-opening/index')">
            <div class="menu-top">
              <img src="@/assets/img/apply-for-invoicing.png" />
            </div>
            <div class="menu-bottom">
              发票填开
            </div>
          </div>
          <div @click="handleGo('/invoice/business/open', 'ELECTRIC_TICKET_STRAIGHT_AWAY')">
            <div class="menu-top">
              <img src="@/assets/img/electric-ticket.png" />
            </div>
            <div class="menu-bottom">
              电票直开
            </div>
          </div>
          <div @click="handleGo('/invoice-red/index')">
            <div class="menu-top">
              <img src="@/assets/img/my-kaipiao.png" />
            </div>
            <div class="menu-bottom">
              负数发票
            </div>
          </div>
        </div>
      </div>
      <div class="segmentation"></div>
      <div class="bottom">
        <van-cell-group>
          <van-cell to="/message/center" title="动态" is-link value="更多" />
        </van-cell-group>
        <div class="dynamic-message-all">
          <DynamicMessage
            v-for="(item, index) in todoData"
            :key="index"
            :list="item"
          ></DynamicMessage>
        </div>
        <div class="advertising-img" @click="handleGoDian('/invoice/business/open','ELECTRIC_TICKET_STRAIGHT_AWAY')">
          <img src="../../assets/img/bottom.png">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Cell, CellGroup, Notify, Dialog } from 'vant'
import moment from 'moment'
import {
  invoiceRequest,
  officialAccountRequest,
  messageRequest
} from '@services'
import { convertBase64UrlToBlob, cutImageBase64, getDayTime, isEmpty } from '@utils/basicUtil'
import DynamicMessage from '@/components/DynamicMessage'
import Observer from '@utils/observer'
export default {
  data () {
    return {
      dayShow: true,
      showInput: false,
      monthShow: false,
      dataSource: {},
      blankInvoiceCount: {},
      applyInvoiceCount: {},
      inDataSource: {},
      unSendTicketCount: null,
      unSignedTicketCount: null,
      searchParams: {
        size: 25,
        current: 1
      },
      none: true,
      dayMoney: {},
      dayOpenMoney: {},
      todoData: []
    }
  },
  async mounted () {
    this.getAnnouncement()
    await this.getStatistics()
    await this.getInData('month')
    await this.getTicketLogistics()
    await this.getDataList()
    Observer.setFunction({
      type: 'changeCompany',
      fn: this.companyChangeRefresh
    })
  },
  methods: {
    async getAnnouncement () {
      let XAccessToken = localStorage.getItem('X-Access-Token')
      if (sessionStorage.noticeShow || !XAccessToken) return
      const res = await messageRequest.notice.getNoticeList()
      if (res.result && Array.isArray(res.result)) {
        const result = res.result || []
        const arr = result.filter(v => v.type === 1)
        let obj = {
          title: 1,
          content: '2'
        }
        if (arr.length) {
          obj = arr[0]
          Dialog({
            title: obj.title,
            closeOnClickOverlay: true,
            confirmButtonColor: '#3378FF',
            className: 'tip-dialog',
            message: decodeURIComponent(obj.content)
          })
          sessionStorage.noticeShow = true
        }
      }
    },
    handleClickCode (code) {
      if (code) {
        this.showInput = !this.showInput
        this.$refs.camera.dispatchEvent(new MouseEvent('click'))
      }
    },
    handleChangeDayCss () {
      this.dayShow = true
      this.monthShow = false
    },
    handleChangeMonthCss () {
      this.dayShow = false
      this.monthShow = true
    },
    handleGoData () {
      this.$router.push('/invoice/data-center')
    },
    onRefresh () {
      this.showInput = false
      this.getStatistics()
      this.getInData('month')
      this.getTicketLogistics()
      this.getDataList()
    },
    companyChangeRefresh () {
      if (window.location.pathname + window.location.search === '/') {
        this.onRefresh()
      }
    },
    handleGo (url, code) {
      if (sessionStorage.noticeShow) {
        sessionStorage.clear()
        sessionStorage.noticeShow = true
      } else {
        sessionStorage.clear()
      }
      if (url === '/invoice-opening/index') {
        this.$store.commit('invoice/initInvoiceOpeningInfo')
        sessionStorage.removeItem('nowGoodsMessage')
        sessionStorage.removeItem('customInfo')
        sessionStorage.removeItem('goods')
      }
      if (url === '/invoice-red/index') {
        this.$store.commit('invoiceRedModel/initInvoiceRedInfo')
      }
      this.$store.state.invoice.goodsList = []
      this.$router.push(url)
    },
    cameraChange () {
      let file = this.camera.files[0]
      cutImageBase64(file, null, 1000, 0.8, data => {
        this.cutSuccess({ base64: data, file: convertBase64UrlToBlob(data) })
      })
    },
    cutSuccess (data) {
      this.$store.commit('invoice/changeImage', data)
      this.$router.push('/newInvoice/collect')
    },
    async getStatistics () {
      const data = await invoiceRequest.statistics.getStatistics({})
      console.log(data)
      if (data.success) {
        this.dataSource = data.result
        this.blankInvoiceCount = {
          ...this.blankInvoiceCount,
          ...data.result.blankInvoiceCount
        }
        this.applyInvoiceCount = {
          ...this.applyInvoiceCount,
          ...data.result.apply
        }
      } else {
        if (data.success === false) {
          Notify({ type: 'danger', message: data.message })
        }
      }
    },
    async getInData (period) {
      let obj = {
        month: {
          startTime: moment()
            .startOf('month')
            .format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment()
            .endOf('month')
            .format('YYYY-MM-DD HH:mm:ss')
        },
        season: {
          startTime: moment()
            .startOf('quarter')
            .format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment()
            .endOf('quarter')
            .format('YYYY-MM-DD HH:mm:ss')
        },
        annual: {
          startTime: moment()
            .startOf('year')
            .format('YYYY-MM-DD HH:mm:ss'),
          endTime: moment()
            .endOf('year')
            .format('YYYY-MM-DD HH:mm:ss')
        }
      }
      let params = {
        ...obj[period]
      }
      const data = await officialAccountRequest.weChat.getTicketStatistics(
        params
      )
      console.log(data.success)
      if (data.success) {
        this.inDataSource = data.result
      }
      let nowDate = getDayTime()
      const DayPutData = await officialAccountRequest.weChat.getTicketStatistics(
        {
          endTime: nowDate + '23:59:59',
          startTime: nowDate + '00:00:00'
        }
      )
      console.log(DayPutData.success)
      if (DayPutData.success) {
        this.dayMoney = DayPutData.result
      }
      const TodoData = await messageRequest.todo.getTodoList({ current: 1, size: 2 })
      if (TodoData.success) {
        this.todoData = TodoData.result.records
      } else {
        Notify({ type: 'danger', message: TodoData.message })
      }
    },
    async getTicketLogistics () {
      const data = await messageRequest.todo.getTicketLogistics({})
      console.log(data.success)
      if (isEmpty(data.success)) {
        this.unSendTicketCount = data.result.unSendTicketIds
          ? data.result.unSendTicketIds.length
          : 0
        this.unSignedTicketCount = data.result.unSignedTicketIds
          ? data.result.unSignedTicketIds.length
          : 0
      }
    },
    async getDataList () {
      const postData = {
        ...this.searchParams
      }
      await messageRequest.todo.getTodoList(postData)
    },
    handleNone () {
      this.none = !this.none
    },
    handleGoDian (url, code) {
      // if (code) {
      //   if (!checkResource(code)) {
      //     resourceTips({ type: 5 })
      //     return
      //   }
      // }
      this.$router.push(url)
    }
  },
  computed: {
    camera: vm => {
      return vm.$refs.camera
    },
    setMoney () {
      return function (item) {
        if (Number(item) < 1000) {
          return '****'
        } else {
          return '******'
        }
      }
    },
    setMonths () {
      return function (money) {
        if (parseInt(money) === 0) {
          return parseInt(money) + '.00'
        } else {
          return parseInt(money) === money ? money + '.00' : money
        }
      }
    }
  },
  components: {
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Notify.name]: Notify,
    DynamicMessage
  }
}
</script>
<style lang="less" scoped src="./style.less"></style>
